import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { reportAnalytics } from '../../TechnicianUpdatesBlockSlice';

const SuccessMsg = (props) =>  {

    return (
        <div className="technician-update-success-msg">
            <p>במידה והוספתם את התזכורת ליומן, זכרו {props.successPageType == "update" ? "לעדכן" : "לבטל"} אותה</p>
            <Image src={require('./images/icons-ok-done@3x.svg')} alt='אייקון הצלחה' />
            <BtnSubmit onclick={() =>props.onClickBtn()} text="סיום" formid="technician--update-success-msg"></BtnSubmit>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        successPageType: state.technicianUpdatesBlock.successPageType
    };
};
  
const mapDispatchToProps = {
    reportAnalytics
};
  
export default connect(mapStateToProps, mapDispatchToProps)(SuccessMsg);